.inner {
  padding: var(--space-4);
}

.content {
  display: flex;
  max-height: calc(100dvh - 2 * var(--space-4));
  overflow: hidden;
  flex-direction: column;
  border: 0.125rem solid var(--color-surface-tinted);
  border-radius: var(--radius-xl);
  color: var(--color-text-primary);
  background: var(--color-surface-raised);
  box-shadow: var(--shadow-block);
}

.header {
  z-index: 1;
  flex: none;
  padding: var(--space-6) var(--space-6) var(--space-3);
  background: var(--color-surface-raised);
}

.title {
  width: 100%;
  color: var(--color-text-primary);
  font-family: var(--font-family-display);
  font-size: clamp(1.125rem, 4vw, 1.5rem);
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.035em;
  overflow-wrap: anywhere;
}

.body {
  min-height: 0;
  overflow-y: auto;
  padding: var(--space-3) var(--space-6) var(--space-6);
  overscroll-behavior: contain;
}

.close {
  width: 2.5rem;
  min-width: 2.5rem;
  height: 2.5rem;
  flex: none;
  border-radius: var(--radius-md);
  color: var(--color-text-primary);
  background: var(--color-surface-subtle);
}

.close:focus-visible {
  outline: 0.125rem solid var(--color-focus);
  outline-offset: 0.125rem;
}

.overlay {
  background: var(--color-modal-overlay);
  backdrop-filter: blur(0.75rem);
}

.sheetContent {
  display: flex;
  max-height: calc(100dvh - env(safe-area-inset-top, 0px) - var(--space-12));
  overflow: hidden;
  flex-direction: column;
  border: 0.125rem solid var(--color-surface-tinted);
  border-bottom: 0;
  border-radius: var(--radius-xl) var(--radius-xl) 0 0;
  color: var(--color-text-primary);
  background: var(--color-surface-raised);
  box-shadow: var(--shadow-block);
}

.sheetDragging {
  transform: translateY(var(--sheet-offset)) !important;
  transition: none !important;
}
.sheetContent[data-content-sized] {
  width: 100%;
  height: auto;
  flex: 0 0 auto;
}
.sheetContent[data-content-sized] .sheetTitle {
  min-width: 0;
}
.sheetContent[data-content-sized] .sheetHeader {
  gap: var(--space-3);
}

.sheetTop {
  flex: none;
  touch-action: none;
}

.sheetHandle {
  width: 3.25rem;
  height: 0.3125rem;
  margin: var(--space-3) auto 0;
  border-radius: var(--radius-pill);
  background: var(--color-text-secondary);
  opacity: 0.45;
}

.sheetHeader {
  align-items: center;
  padding: var(--space-5) var(--space-5) 0;
  background: transparent;
}

.sheetTitle {
  width: 100%;
  margin: 0;
  color: var(--color-text-primary);
  font-family: var(--font-family-display);
  font-size: clamp(1.5rem, 4vw, 2rem);
  font-weight: 850;
  line-height: 1.1;
  letter-spacing: -0.045em;
  overflow-wrap: anywhere;
}

.sheetClose {
  width: 2.5rem;
  min-width: 2.5rem;
  height: 2.5rem;
  border-radius: var(--radius-md);
  color: var(--color-text-primary);
  background: var(--color-surface-subtle);
  box-shadow: var(--shadow-control);
}

.sheetBody {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: var(--space-5) var(--space-5) calc(var(--space-8) + env(safe-area-inset-bottom, 0px));
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;
}

@media (hover: hover) and (pointer: fine) {
  .close:hover {
    background: var(--color-surface-tinted);
  }

  .sheetClose:hover {
    background: var(--color-surface-tinted);
  }
}

@media (max-width: 35.99em) {
  .inner {
    padding: 0;
  }

  .content {
    width: 100%;
    height: 100dvh;
    max-height: 100dvh;
    border: 0;
    border-radius: 0;
  }

  .header {
    padding-top: calc(var(--space-5) + env(safe-area-inset-top, 0px));
  }

  .body {
    padding-bottom: calc(var(--space-6) + env(safe-area-inset-bottom, 0px));
  }
}
